import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import { db, auth, provider } from "../firebase/fireabase";

import { getDoc } from "firebase/firestore";

import {
  getAuth,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  FacebookAuthProvider,
} from "firebase/auth";

import Login from "./Login";
function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // Add this line
  const navigate = useNavigate();

  const handleReset = () => {
    setEmail("");
    setPassword("");
    setError(""); // Reset error message
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const auth = getAuth();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      // Signed in
      const user = userCredential.user;
      localStorage.setItem("user", JSON.stringify(user));
      handleReset();
      navigate("/myprofile/" + user.uid, { replace: true });
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      setError(errorMessage); // Set error message
    }
  };

  // sing in using facebook

  const handleLoginWithFacebook = (event) => {
    signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Facebook Access Token. You can use it to access the Facebook API.
        const credential = FacebookAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;
        fetch(
          `https://graph.facebook.com/v11.0/me?fields=id,name,email,picture&access_token=${token}`
        )
          .catch((error) => {
            console.log(error);
          })
          .then((response) => {
            response.json().then((data) => {
              console.log(data, "facebook data");
              // Add the user to the "users" collection in Firestore
              setDoc(doc(db, "users", user.uid), {
                name: data.name,
                email: data.email || user.email,
                phoneNumber: user.phoneNumber,
                photoURL: data.picture.data.url,
                craetedAt: new Date().toISOString(),
              });

              localStorage.setItem("user", JSON.stringify(user));
              navigate("/", { replace: true });
            });
          });

        // Check if user already exists in the database
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          // If the user does not exist, save it to the database
          setDoc(docRef, {
            name: user.displayName,
            email: user.email,
            // add other user properties here
          });
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        setError(errorMessage); // Set error message
      });
  };

  const handleLoginWithGoogle = (event) => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;

        localStorage.setItem("user", JSON.stringify(user));
        navigate("/myprofile/" + user.uid, { replace: true });

        // Check if user already exists in the database
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          // If the user does not exist, save it to the database
          setDoc(docRef, {
            name: user.displayName,
            email: user.email,
            // add other user properties here
          });
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        setError(errorMessage);
      });
  };

  return (
    <React.Fragment>
      <Login
        email={email}
        password={password}
        setEmail={setEmail}
        setPassword={setPassword}
        handleLogin={handleLogin}
        handleLoginWithGoogle={handleLoginWithGoogle}
        error={error}
        facebookSignup={handleLoginWithFacebook}
      />
    </React.Fragment>
  );
}

export default LoginPage;
